// Resolve Avatar workspace root từ current cwd qua walk-up search.
//
// Marker định danh DUY NHẤT: .claude/avatar.json — file đặc thù Avatar, ghi lúc
// init. KHÁC tên với avatar-po (.claude/avatar-po.json) → cô lập tuyệt đối 2 CLI:
// avatar CHỈ nhận workspace của chính nó, không đụng workspace avatar-po.
//
// v3.16.0: BỎ nhánh fallback structure-based (.claude/+CLAUDE.md+pack/). Fallback
// cũ nhận workspace qua cấu trúc khi thiếu marker → nhận NHẦM cross-CLI (avatar và
// avatar-po workspace cùng có .claude/pack/). Mọi workspace hiện tại đều có marker
// file nên fallback thừa; bỏ để khép kín cô lập.
import { existsSync } from "node:fs";
import { dirname, join } from "node:path";
import {
  FOREIGN_WORKSPACE_MARKER_RELATIVE,
  WORKSPACE_MARKER_RELATIVE,
} from "./workspace-marker-constants.js";

const MAX_WALKUP_LEVELS = 5;

// Check thư mục có phải Avatar workspace không — CHỈ qua marker đặc thù.
function isAvatarWorkspace(dir: string): boolean {
  return existsSync(join(dir, WORKSPACE_MARKER_RELATIVE));
}

// Walk-up từ startDir tìm Avatar workspace root.
// Trả về path workspace nếu tìm thấy, null nếu không.
export function resolveAvatarWorkspaceRootFromCwd(startDir: string): string | null {
  let current = startDir;
  for (let i = 0; i < MAX_WALKUP_LEVELS; i++) {
    if (isAvatarWorkspace(current)) return current;
    const parent = dirname(current);
    if (parent === current) return null; // Reached filesystem root.
    current = parent;
  }
  return null;
}

// Nhận diện "đứng nhầm nhà": cwd (hoặc tổ tiên) là workspace của CLI KIA (avatar-po)
// chứ không phải avatar. Dùng để báo lỗi hướng dẫn đúng CLI thay vì xui init đè.
// Trả "avatar-po" nếu tìm thấy marker po mà KHÔNG có marker avatar; null nếu không.
export function detectForeignWorkspaceFromCwd(startDir: string): "avatar-po" | null {
  let current = startDir;
  for (let i = 0; i < MAX_WALKUP_LEVELS; i++) {
    if (isAvatarWorkspace(current)) return null; // marker mình thắng — không nhầm nhà
    if (existsSync(join(current, FOREIGN_WORKSPACE_MARKER_RELATIVE))) return "avatar-po";
    const parent = dirname(current);
    if (parent === current) return null;
    current = parent;
  }
  return null;
}
